import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.features.get-po-bill-to-settings.presenters.use-po-bill-to-settings-presenter`

export default defineMessages({
  contactUserFetchErrorTitle: {
    id: `${scope}.contactUserFetchErrorTitle`,
    defaultMessage: 'Error',
  },
  contactUserFetchErrorMessage: {
    id: `${scope}.contactUserFetchErrorMessage`,
    defaultMessage: 'Failed to load the saved bill to contact user.',
  },
  preferencesFetchErrorTitle: {
    id: `${scope}.preferencesFetchErrorTitle`,
    defaultMessage: 'Error',
  },
  preferencesFetchErrorMessage: {
    id: `${scope}.preferencesFetchErrorMessage`,
    defaultMessage: 'Failed to load the saved bill to defaults.',
  },
})
